import CheckIcon from '@/assets/icons/check.svg?react';
import { cn } from '@/shared/lib/cn';
import { formatMoney } from '@/shared/lib/format';
import { Pill } from '@/shared/ui/pill';
import { RadioDot } from '@/shared/ui/radio';
import type { PlanData } from '../types';

type PlanOptionProps = {
  plan: PlanData;
  isChecked: boolean;
  isCurrent: boolean;
  onPick: () => void;
};

export function PlanOption({ plan, isChecked, isCurrent, onPick }: PlanOptionProps) {
  return (
    <label
      className={cn(
        'flex cursor-pointer flex-col gap-3.5 rounded-card border-2 bg-surface p-5 text-left transition-tone has-disabled:cursor-not-allowed has-focus-visible:outline-2 has-focus-visible:outline-accent has-focus-visible:outline-offset-2',
        isChecked ? 'border-accent-mark' : 'border-transparent hover:bg-surface-2',
      )}
    >
      <input
        type="radio"
        name="plan"
        value={plan.id}
        checked={isChecked}
        disabled={isCurrent}
        onChange={onPick}
        className="sr-only"
      />
      <span className="flex items-center gap-3">
        <RadioDot isChecked={isChecked} />
        <span className="font-semibold text-card-title">{plan.name}</span>
        {isCurrent ? <Pill tone="off">Current plan</Pill> : null}
        <span className="ml-auto tabular-nums">
          <span className="font-semibold text-price">
            {formatMoney(plan.priceCents, 'USD', true)}
          </span>{' '}
          <span className="text-muted">a month</span>
        </span>
      </span>
      <ul className="flex flex-col gap-1.5 pl-8">
        {plan.lines.map((line) => (
          <li key={line} className="grid grid-cols-[18px_1fr] items-start gap-2.5">
            <CheckIcon aria-hidden="true" className="mt-0.75 size-4 text-ok-text" />
            <span>{line}</span>
          </li>
        ))}
      </ul>
    </label>
  );
}
